var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_content"},[_c('div',{staticClass:"breadcrumbs"}),(!_vm.loading)?_c('div',{staticClass:"help"},[_c('config-bar',{staticClass:"help_bar"}),_c('v-sheet',{staticClass:"help_main",class:( _obj = {}, _obj['help_full-height'] = _vm.routeName === 'help-cam-select', _obj )},[_c('router-view')],1)],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }